import { Avatar, Badge } from '@mui/material'

import { StepIconBadge } from './step-icon-badge.component'
import { IStepAccountsBaseWithId } from 'src/types'

interface IProps {
  name: string
  image_small: string | null
  image: string
  connection: Pick<IStepAccountsBaseWithId, 'account_approved' | 'account'> | null
}

export const StepIcon = ({ name, image_small, image, connection }: IProps) => {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={connection ? <StepIconBadge connection={connection} /> : null}
    >
      <Avatar alt={name} src={image_small || image} />
    </Badge>
  )
}
